import { ChannelImportRow, parseChannelImportLinks, validateChannelImportRows } from '../../../domain/entities/ChannelImportDraft';
import { IChannelImportRepository } from '../../ports/IChannelImportRepository';

export class StartChannelImportUseCase {
  constructor(private repo: IChannelImportRepository) {}
  execute(rawLinks: string, telegramAccountUuid: string) {
    return this.repo.start(parseChannelImportLinks(rawLinks), telegramAccountUuid);
  }
}

export class GetChannelImportUseCase {
  constructor(private repo: IChannelImportRepository) {}
  execute(uuid: string) {
    return this.repo.get(uuid);
  }
}

export class ListChannelImportsUseCase {
  constructor(private repo: IChannelImportRepository) {}
  execute() {
    return this.repo.listRecent();
  }
}

export class SaveChannelImportRowsUseCase {
  constructor(private repo: IChannelImportRepository) {}
  execute(uuid: string, rows: ChannelImportRow[]) {
    return this.repo.saveRows(uuid, validateChannelImportRows(rows));
  }
}

export class ApplyChannelImportUseCase {
  constructor(private repo: IChannelImportRepository) {}
  execute(uuid: string, dryRun: boolean) {
    return this.repo.apply(uuid, dryRun);
  }
}
